import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import EntrepreneurHero from "../components/entrepreneur/EntrepreneurHero";
import Entrepreneur from "../components/entrepreneur/Entrepreneur";
import EntrepreneurForm from "../components/entrepreneur/EntrepreneurForm";
import { Header, Footer } from "../shared";

const EntrepreneurPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="BuyCertifiedDrone_backgorund">
      <div className="bg_darkblue">
        <Header />
      </div>
      <EntrepreneurHero />
      <Entrepreneur />
      <EntrepreneurForm />
      <Footer />
    </div>
  );
};

export default EntrepreneurPage;
